<ng-template #subtaskEditor let-config>
	<div *ngFor="let sub of config.list; let i = index" class="border border-lightgrey rounded p-3 mb-2">
		<div class="d-flex">
			<div class="flex-weight-1 mr-2">
				<input class="form-control mb-2" placeholder="Subtask name" [(ngModel)]="sub.name" [ngModelOptions]="{ standalone: true }" autocomplete="chrome-off">
				<textarea rows="2" class="form-control" placeholder="Description" [(ngModel)]="sub.description" [ngModelOptions]="{ standalone: true }"></textarea>
			</div>
			<button type="button" class="btn btn-outline-secondary btn-sm px-2 border-0 align-self-start" (click)="removeSubtask(config.list, i)" ngbTooltip="Remove subtask"><i class="wq wq-delete"></i></button>
		</div>
		<div class="d-flex flex-wrap align-items-center mt-2">
			<ui-checkbox-dropdown *ngIf="config.dependencies?.length" class="mr-3 mb-2" dropdownName="Dependencies" [items]="config.dependencies" [maxShown]="1" selectProp="id" [selectedItems]="sub.dependencies" (selectionChange)="subtaskDependencyChange($event, sub)"></ui-checkbox-dropdown>
		</div>
		<div class="d-flex flex-wrap align-items-center">
			<input class="form-control w-5r d-inline-block mr-1" [(ngModel)]="sub.duration" (change)="subtaskDurationChanged(sub)" [ngModelOptions]="{ standalone: true }" autocomplete="chrome-off">
			<select class="custom-select w-auto mr-3" [(ngModel)]="sub.duration_type" [ngModelOptions]="{ standalone: true }">
				<option value="min">mins</option>
				<option value="hour">hours</option>
			</select>
			<label class="custom-control custom-checkbox">
				<input type="checkbox" class="custom-control-input" [ngModel]="!!sub.billable" (ngModelChange)="sub.billable = $event ? 1 : 0" [ngModelOptions]="{ standalone: true }">
				<span class="custom-control-label">Billable?</span>
			</label>
		</div>
	</div>
	<button *ngIf="config.showAdd" type="button" class="btn btn-outline-secondary btn-sm mt-2" (click)="addSubtask(config.list)"><i class="wq wq-add mr-1"></i> Add subtask</button>
</ng-template>

<form>
	<ui-modal [modalTitle]="modalTitle" [scrollable]="true">
		<div *ngIf="details?.task.type === 'simple' || details?.task.type === 'bulk' || details?.task.type === 'parent'" ui-modal-header>

			<div class="dropdown dropdown-light d-inline-block mr-2">
				<button type="button" class="btn btn-outline-secondary border-0 p-2 mr-2 dropdown-toggle" data-toggle="dropdown"><i class="wq wq-more"></i></button>
				<div class="dropdown-menu dropdown-menu-right border-primary">
					<button type="button" class="dropdown-item" (click)="saveAsTemplate()">Save as task template</button>
				</div>
			</div>
		</div>

		<ng-container *ngIf="details">
			<ui-form labelWidth="10rem">
				<ui-form-control label="Task Name">
					<input class="form-control" [(ngModel)]="details.task.name" [ngModelOptions]="{ standalone: true }" autocomplete="chrome-off" appDesktopFocus>
				</ui-form-control>

				<ui-form-control label="Description">
					<textarea rows="10" class="form-control" [(ngModel)]="details.task.description" [ngModelOptions]="{ standalone: true }"></textarea>
				</ui-form-control>

				<ui-form-control *ngIf="details.dependencies.length" label="Dependencies">
					<ui-checkbox-dropdown [items]="details.dependencies" selectProp="id" [selectedItems]="details.task.dependencies" (selectionChange)="dependencyChange($event)"></ui-checkbox-dropdown>
				</ui-form-control>

				<ui-form-control *ngIf="details.users?.length" label="Assign Users">
					<ui-checkbox-dropdown [items]="details.users" selectProp="id" [selectedItems]="assignedUsersSelected" [lockedItems]="details.task.locked_users" (selectionChange)="assignedUsersChange($event)"></ui-checkbox-dropdown>
					<div *ngIf="details.task.locked_users?.length" class="text-secondary text-small mt-2"><i class="wq wq-info mr-1"></i>Users who have recorded time on this task are assigned automatically and can't be unassigned.</div>
				</ui-form-control>

				<ui-form-control *ngIf="details.task.type !== 'parent'" label="Task Duration">
					<input class="form-control w-20 d-inline-block mr-1" [(ngModel)]="details.task.duration" (change)="durationChanged()" [ngModelOptions]="{ standalone: true }" autocomplete="chrome-off">
					<select class="custom-select w-auto" [(ngModel)]="details.task.duration_type" [ngModelOptions]="{ standalone: true }">
						<option value="min">mins</option>
						<option value="hour">hours</option>
					</select>
					<i class="wq wq-info text-info ml-2 text-large" *ngIf="details.task.extra_labour.length" [ngbTooltip]="durationTip" container="body"></i>
				</ui-form-control>
				<ng-template #durationTip>
					<div>{{extractedHours | decimal:0:4}} extracted {{extractedHours === 1 ? 'hour' : 'hours'}}</div>
					<div>{{extraHours | decimal:0:4}} extra {{extraHours === 1 ? 'hour' : 'hours'}}</div>
				</ng-template>

				<ui-form-control>
					<label class="custom-control custom-checkbox w-20">
						<input type="checkbox" class="custom-control-input" [ngModel]="!!details.task.billable" (ngModelChange)="details.task.billable = $event ? 1 : 0" [ngModelOptions]="{ standalone: true }">
						<span class="custom-control-label">Billable?</span>
					</label>
				</ui-form-control>

				<ui-form-control label="Phase" *ngIf="details.phases.length && !details.task.parent_id">
					<select class="custom-select" [(ngModel)]="details.task.phase_id" [ngModelOptions]="{ standalone: true }">
						<option [ngValue]="null"></option>
						<option *ngFor="let p of details.phases" [ngValue]="p.id">{{p.name}}</option>
					</select>
				</ui-form-control>

				<ui-form-control label="Priority">
					<div class="d-flex align-items-center pt-2">
						<label class="custom-control custom-radio mr-4 selectable">
							<input type="radio" class="custom-control-input" name="priority" value="0" [(ngModel)]="priority" checked>
							<ui-task-priority priority="0" class="custom-control-label"></ui-task-priority>
						</label>
						<label class="custom-control custom-radio mr-4 selectable">
							<input type="radio" class="custom-control-input" name="priority" value="1" [(ngModel)]="priority">
							<ui-task-priority priority="1" class="custom-control-label"></ui-task-priority>
						</label>
						<label class="custom-control custom-radio selectable">
							<input type="radio" class="custom-control-input" name="priority" value="2" [(ngModel)]="priority">
							<ui-task-priority priority="2" class="custom-control-label"></ui-task-priority>
						</label>
					</div>
				</ui-form-control>

				<ui-form-control *ngIf="details.assign_system" label="System">
					<select class="custom-select" [(ngModel)]="details.task.category_id" [ngModelOptions]="{ standalone: true }">
						<option [ngValue]="null">Unassigned</option>
						<optgroup *ngFor="let cg of details.category_groups" label="{{cg.description}}">
							<option *ngFor="let c of cg.categories" [ngValue]="c.id">{{c.description}}</option>
						</optgroup>
					</select>
				</ui-form-control>

				<ui-form-control *ngIf="details.assign_area" label="Area">
					<select class="custom-select" [(ngModel)]="details.task.structure_id" [ngModelOptions]="{ standalone: true }">
						<option [ngValue]="null">Unassigned</option>
						<optgroup *ngFor="let ag of details.area_groups" label="{{ag.description}}">
							<option *ngFor="let a of ag.areas" [ngValue]="a.id">{{a.description}}</option>
						</optgroup>
					</select>
				</ui-form-control>

				<ui-form-control label="Group By" *ngIf="!details.task.parent_id && details.task.type === 'parent'">
					<select class="custom-select w-auto" [(ngModel)]="details.task.group_by" [ngModelOptions]="{ standalone: true }">
						<option [ngValue]="null">None</option>
						<option value="system">System</option>
						<option value="area">Area</option>
					</select>
				</ui-form-control>

				<ui-form-control *ngIf="details.task.type === 'parent' && details.task.subtasks?.length" label="Subtasks">
					<div class="text-secondary mt-2">
						<span *ngIf="subtaskItemised">{{subtaskItemised}} itemised{{subtaskSimple ? ', ' : ''}}</span>
						<span *ngIf="subtaskSimple">{{subtaskSimple}} simple</span>
					</div>
				</ui-form-control>

				<ui-form-control *ngIf="id === 'new' && details.task.type === 'simple' && !details.task.parent_id" label="Subtasks">
					<div class="mt-2">
						<ng-container *ngTemplateOutlet="subtaskEditor; context: { $implicit: { list: details.task.subtasks, showAdd: true, dependencies: details.dependencies } }"></ng-container>
					</div>
				</ui-form-control>
			</ui-form>

			<ng-container *ngIf="details.task.extra_labour.length">
				<h3 class="mt-5">Additional Labour</h3>
				<table class="table table-hover vam">
					<tbody>
						<tr *ngFor="let lt of details.task.extra_labour">
							<td class="text-bold">{{lt.description}}</td>
							<td class="shrink nowrap">
								<div class="d-inline-block">
									<div class="input-group flex-nowrap">
										<input type="text" class="form-control w-7r text-right" [(ngModel)]="lt.hours" [ngModelOptions]="{ standalone: true }" (change)="formatNumbers()" autocomplete="chrome-off">
										<div class="input-group-append">
											<span class="input-group-text" style="min-width: 7rem;">/ {{lt.hours_left | decimal:0:4}} {{lt.hours_left === 1 ? 'hour' : 'hours'}}</span>
										</div>
									</div>
								</div>
							</td>
						</tr>
					</tbody>
				</table>
			</ng-container>
		</ng-container>

		<button *ngIf="id !== 'new'" type="button" class="btn btn-danger" (click)="deleteTask()" [disabled]="disabled" ui-modal-footer>Delete</button>
		<button *ngIf="id !== 'new' && details?.task.stage === 'completed' && details?.task.stage !== 'follow_up'" type="button" class="btn btn-success" (click)="markAsActive()" [disabled]="disabled" ui-modal-footer>Mark As Active</button>
		<button *ngIf="id !== 'new' && details?.task.stage !== 'completed' && details?.task.stage !== 'follow_up'" type="button" class="btn btn-success" (click)="markAsCompleted()" [disabled]="disabled" ui-modal-footer>Mark As Complete</button>
		<div class="flex-weight-1" ui-modal-footer></div>
		<button type="button" class="btn btn-secondary" (click)="modal.close()" [disabled]="disabled" ui-modal-footer>Cancel</button>
		<button type="submit" class="btn btn-primary" (click)="save()" [disabled]="disabled" ui-modal-footer>Save</button>
	</ui-modal>
</form>

<ui-modal modalTitle="Create new task" size="sm" [scrollable]="true" [footer]="false" #selectTaskTemplateModal>
	<ng-container *ngIf="taskTemplates">
		<div>Create from scratch:</div>
		<div class="d-flex flex-column">
			<button class="btn btn-outline-secondary mt-2" (click)="selectTemplate()" [disabled]="disabled">New Simple Task</button>
		</div>
		<ng-container *ngIf="taskTemplates.length">
			<div class="mt-3">Create from template:</div>
			<div class="d-flex flex-column">
				<div *ngFor="let t of taskTemplates" class="btn-group">
					<button class="btn btn-outline-secondary mt-2" (click)="selectTemplate(t)" [disabled]="disabled">{{t.template_name}}</button>
					<button class="btn btn-outline-secondary mt-2 flex-weight-0 px-2" (click)="editTemplate(t)" ngbTooltip="Edit Template" [disabled]="disabled"><i class="wq wq-edit"></i></button>
					<button class="btn btn-outline-secondary mt-2 flex-weight-0 px-2" (click)="deleteTemplate(t)" ngbTooltip="Delete Template" [disabled]="disabled"><i class="wq wq-delete"></i></button>
				</div>
			</div>
		</ng-container>
	</ng-container>
</ui-modal>

<form>
	<ui-modal [modalTitle]="editingTemplateId ? 'Edit Task Template' : 'Save as Task Template'" size="md" [scrollable]="true" #saveAsTaskTemplateModal>
		<ui-form *ngIf="saveAsTaskTemplateModal.isOpen" direction="vertical">
			<ui-form-control label="Template Name">
				<input class="form-control" [(ngModel)]="templateName" [ngModelOptions]="{ standalone: true }" autocomplete="chrome-off" appDesktopFocus>
			</ui-form-control>

			<ng-container *ngIf="editingTemplateId">
				<ui-form-control label="Task Name">
					<input class="form-control" [(ngModel)]="templateData.name" [ngModelOptions]="{ standalone: true }" autocomplete="chrome-off">
				</ui-form-control>
				<ui-form-control label="Description">
					<textarea rows="3" class="form-control" [(ngModel)]="templateData.description" [ngModelOptions]="{ standalone: true }"></textarea>
				</ui-form-control>
				<ui-form-control label="Dependencies" *ngIf="templateDependencies.length">
					<ui-checkbox-dropdown [items]="templateDependencies" selectProp="id" [selectedItems]="templateData.dependencies" (selectionChange)="subtaskDependencyChange($event, templateData)"></ui-checkbox-dropdown>
				</ui-form-control>
				<ui-form-control label="Task Duration">
					<input class="form-control w-20 d-inline-block mr-1" [(ngModel)]="templateData.duration" (change)="subtaskDurationChanged(templateData)" [ngModelOptions]="{ standalone: true }" autocomplete="chrome-off">
					<select class="custom-select w-auto" [(ngModel)]="templateData.duration_type" [ngModelOptions]="{ standalone: true }">
						<option value="min">mins</option>
						<option value="hour">hours</option>
					</select>
				</ui-form-control>
				<ui-form-control>
					<label class="custom-control custom-checkbox w-20">
						<input type="checkbox" class="custom-control-input" [ngModel]="!!templateData.billable" (ngModelChange)="templateData.billable = $event ? 1 : 0" [ngModelOptions]="{ standalone: true }">
						<span class="custom-control-label">Billable?</span>
					</label>
				</ui-form-control>
				<ui-form-control label="Phase" *ngIf="templatePhases.length">
					<select class="custom-select" [(ngModel)]="templateData.phase_id" [ngModelOptions]="{ standalone: true }">
						<option [ngValue]="null"></option>
						<option *ngFor="let p of templatePhases" [ngValue]="p.id">{{p.name}}</option>
					</select>
				</ui-form-control>
			</ng-container>

			<ui-form-control *ngIf="templateSubtasks.length || id !== 'new' || editingTemplateId" label="Subtasks">
				<ng-container *ngTemplateOutlet="subtaskEditor; context: { $implicit: { list: templateSubtasks, showAdd: id !== 'new' || editingTemplateId, dependencies: templateDependencies } }"></ng-container>
			</ui-form-control>
		</ui-form>

		<button type="button" class="btn btn-secondary" (click)="saveAsTaskTemplateModal.close()" [disabled]="disabled" ui-modal-footer>Cancel</button>
		<button type="submit" class="btn btn-primary" (click)="saveTaskTemplate()" [disabled]="disabled" ui-modal-footer>Save</button>
	</ui-modal>
</form>
